module.exports = __webpack_public_path__ + "media/theme/blog__border-10-6167206e.png";